import { getTopFiveLeagues } from "../../js/api/topfiveleague.js";
import { getTopTenMatchGames } from "../../js/api/toptenprematchgames.js";
import { getTopTenLiveGames } from "../../js/api/toptenlivegames.js";
import { sports } from '../components/Leftpanel.js';
import { getTopTenLiveTemplate } from "../templates/top-ten-live-games.js";
import { getFeaturedMatches, getTodayMatches } from "../../js/api/featuredPreMatch.js";
import { getPrematchGamesMainLeague } from "../../js/api/mainLeagueMatch.js";
import { getLiveTemplate } from "../templates/live-games.js";
import { _t } from "../../services/TranslationService.js";
import { getPokerUrl, LOGIN_PROTECTED } from "../../js/constants/global-variables.js";


let timers = [];
let Landing = {
  render: async () => {
    if (LOGIN_PROTECTED === true && !localStorage.getItem('access_token')) {
      return '';
    }

    const blockedSports = JSON.parse(localStorage.getItem('blockedSports') ?? '[]');
    const sport_id = 1;
    const blockedFootball = blockedSports.indexOf(sport_id.toString()) !== -1;
    
    let featuredPrematchs = blockedFootball ? [] : await getFeaturedMatches(sport_id);
    let featuredPrematchView = '';
    let todayMatchesView = '';
    let next2hMatchesView = '';
    let next4hMatchesView = '';
    let mainLeagueMatches = blockedFootball ? [] : await getPrematchGamesMainLeague();
    let todayMatches = blockedFootball ? [] : (await getTodayMatches()).map(m => {
      m['whole_date_timestamp'] = new Date(m.whole_date).getTime();
      return m;
    });
    const now = new Date().getTime();
    const next2hTimestamp = now + (2 * 60 * 60 * 1000);
    const next4hTimestamp = now + (4 * 60 * 60 * 1000);
    const next2hMatches = todayMatches.filter(match => match.whole_date_timestamp > now && match.whole_date_timestamp < next2hTimestamp);
    const next4hMatches = todayMatches.filter(match => match.whole_date_timestamp > now && match.whole_date_timestamp < next4hTimestamp);

    // console.log('next 2h matches', next2hMatches);
    // console.log('next 4h matches', next4hMatches);
    

    let mainLeagueMatchesView = '';

    let mainLeagueName = mainLeagueMatches && mainLeagueMatches[0] ? mainLeagueMatches[0].league : '';
  


    if (featuredPrematchs) {
      featuredPrematchs.forEach((featuredPrematch) => {

        if (featuredPrematch.odd) {
          const date = new Date(featuredPrematch.game_date);
          let dd = String(date.getDate()).padStart(2, '0');
          let mm = String(date.getMonth() + 1).padStart(2, "0"); //January is 0!
          let yyyy = date.getFullYear();

          const time = `${featuredPrematch.game_time.split(":")[0]}:${featuredPrematch.game_time.split(":")[1]}`
          featuredPrematchView = featuredPrematchView + `<div class="featuredPrematchItem">
             <a href="#/Match/${featuredPrematch.id}" class="featuredMatchName">
                <span>
                  <span class="kfm-Competitor_TeamKit">
                    <object data="${window.location.pathname}img/kit-black.svg" type="image/svg">
                      <img class="ml-TeamKit_SVG" src="${window.location.pathname}img/kit-black.svg" />
                    </object>
                  </span>
                  ${featuredPrematch.home_team}
                </span>
                <span>
                  <span class="kfm-Competitor_TeamKit">
                    <object data="${window.location.pathname}img/kit-yellow.svg" type="image/svg">
                      <img class="ml-TeamKit_SVG" src="${window.location.pathname}img/kit-yellow.svg" />
                    </object>
                  </span>
                  ${featuredPrematch.away_team}
                </span>
              </a>
              <span class="featurePreMatchDate">${dd}/${mm} ${time}</span>
                      <span class="numberofmarkets">${featuredPrematch.count_options} ></span>
              <div class="featuredMatchBtn">
                   <div class="singleHomeOdd bettingBtn ${Math.floor((parseFloat(featuredPrematch.odd.split(',')[0].split('|')[1]) + Number.EPSILON) * 100) / 100 == 1 ? 'disabledBtn' : ''} ${featuredPrematch.odd.split(',')[0].split('|')[0]}" match-odd="${(Math.floor((parseFloat(featuredPrematch.odd.split(',')[0].split('|')[1]) + Number.EPSILON) * 100) / 100).toFixed(2)}" match-home-name="${featuredPrematch.home_team}" match-away-name="${featuredPrematch.away_team}" match-market="${["1", "X", "2"].includes(featuredPrematch.odd.split(',')[0].split('|')[2]) ? "Rezultat final" : featuredPrematch.odd.split(',')[0].split('|')[2]}" coef-id="${featuredPrematch.odd.split(',')[0].split('|')[0]}" match-market-option="1 " bet-id="${(featuredPrematch.odd.split(',')[0].split('|')[0])}" game-id="${featuredPrematch.id}"><i>1</i><i>${(Math.floor((parseFloat(featuredPrematch.odd.split(',')[0].split('|')[1]) + Number.EPSILON) * 100) / 100).toFixed(2)}</i></div>
                   <div class="singleDrawOdd bettingBtn ${Math.floor((parseFloat(featuredPrematch.odd.split(',')[1].split('|')[1]) + Number.EPSILON) * 100) / 100 == 1 ? 'disabledBtn' : ''} ${featuredPrematch.odd.split(',')[1].split('|')[0]}" match-odd="${(Math.floor((parseFloat(featuredPrematch.odd.split(',')[1].split('|')[1]) + Number.EPSILON) * 100) / 100).toFixed(2)}" match-home-name="${featuredPrematch.home_team}" match-away-name="${featuredPrematch.away_team}" match-market="${["1", "X", "2"].includes(featuredPrematch.odd.split(',')[1].split('|')[2]) ? "Rezultat final" : featuredPrematch.odd.split(',')[1].split('|')[2]}" coef-id="${featuredPrematch.odd.split(',')[1].split('|')[0]}" match-market-option="X " bet-id="${(featuredPrematch.odd.split(',')[1].split('|')[0])}" game-id="${featuredPrematch.id}"><i>X</i><i>${(Math.floor((parseFloat(featuredPrematch.odd.split(',')[1].split('|')[1]) + Number.EPSILON) * 100) / 100).toFixed(2)}</i></div>
                   <div class="singleAwayOdd bettingBtn ${Math.floor((parseFloat(featuredPrematch.odd.split(',')[2].split('|')[1]) + Number.EPSILON) * 100) / 100 == 1 ? 'disabledBtn' : ''} ${featuredPrematch.odd.split(',')[2].split('|')[0]}" match-odd="${(Math.floor((parseFloat(featuredPrematch.odd.split(',')[2].split('|')[1]) + Number.EPSILON) * 100) / 100).toFixed(2)}" match-home-name="${featuredPrematch.home_team}" match-away-name="${featuredPrematch.away_team}" match-market="${["1", "X", "2"].includes(featuredPrematch.odd.split(',')[2].split('|')[2]) ? "Rezultat final" : featuredPrematch.odd.split(',')[2].split('|')[2]}" coef-id="${featuredPrematch.odd.split(',')[2].split('|')[0]}" match-market-option="2 " bet-id="${(featuredPrematch.odd.split(',')[2].split('|')[0])}" game-id="${featuredPrematch.id}"><i>2</i><i>${(Math.floor((parseFloat(featuredPrematch.odd.split(',')[2].split('|')[1]) + Number.EPSILON) * 100) / 100).toFixed(2)}</i></div>
              </div>
        </div>`
        }
      });

    }

    const generateMatchesView = (matches) => {
      let matchesView = '';

      if (!matches || (matches && matches.length === 0)) return `<p style="color: white; font-size: 12px; padding: 15px;">${_t('Nuk ka ndeshje te planifikuara per kete periudhe kohore')}</p>`;
      
      const uniqueLeaguesTodayMatches = [
        ...new Set(matches.map((item) => item.league_id)),
      ];

      uniqueLeaguesTodayMatches.forEach((leagueId) => {
        let singleDateView = "";
        let leagueName = "";

        matches
          .filter((a) => a.league_id === leagueId)
          .map((todayMatch) => {
            leagueName = todayMatch.league;

            if (todayMatch.odd) {
              const date = new Date(todayMatch.game_date);
              let dd = String(date.getDate()).padStart(2, '0');
              let mm = String(date.getMonth() + 1).padStart(2, "0"); //January is 0!
              let yyyy = date.getFullYear();

              const time = `${todayMatch.game_time.split(":")[0]}:${todayMatch.game_time.split(":")[1]}`
              try {
                singleDateView = singleDateView + `
                  <div class="featuredPrematchItem">
                    <div class="helperLeftContentMatch">
                      <a href="#/Match/${todayMatch.id}?today=1" class="featuredMatchName">
                        <span>${todayMatch.home_team}</span>
                        <span>${todayMatch.away_team}</span>
                      </a>
                      <span class="featurePreMatchDate">${dd}/${mm} ${time}</span>
                      <span class="numberofmarkets">${todayMatch.count_options} ></span>
                    </div>
                    <div class="featuredMatchBtn">
                      <div class="singleHomeOdd bettingBtn ${Math.floor((parseFloat(todayMatch.odd.split(',')[0].split('|')[1]) + Number.EPSILON) * 100) / 100 == 1 ? 'disabledBtn' : ''} ${todayMatch.odd.split(',')[0].split('|')[0]}" match-odd="${(Math.floor((parseFloat(todayMatch.odd.split(',')[0].split('|')[1]) + Number.EPSILON) * 100) / 100).toFixed(2)}" match-home-name="${todayMatch.home_team}" match-away-name="${todayMatch.away_team}" match-market="${["1", "X", "2"].includes(todayMatch.odd.split(',')[0].split('|')[2]) ? "Rezultat final" : todayMatch.odd.split(',')[0].split('|')[2]}"  match-market-option="1 " coef-id="${todayMatch.odd.split(',')[0].split('|')[0]}" bet-id="${(todayMatch.odd.split(',')[0].split('|')[0])}" game-id="${todayMatch.id}"><i>1</i><i>${(Math.floor((parseFloat(todayMatch.odd.split(',')[0].split('|')[1]) + Number.EPSILON) * 100) / 100).toFixed(2)}</i></div>
                      <div class="singleDrawOdd bettingBtn ${Math.floor((parseFloat(todayMatch.odd.split(',')[1].split('|')[1]) + Number.EPSILON) * 100) / 100 == 1 ? 'disabledBtn' : ''} ${todayMatch.odd.split(',')[1].split('|')[0]}" match-odd="${(Math.floor((parseFloat(todayMatch.odd.split(',')[1].split('|')[1]) + Number.EPSILON) * 100) / 100).toFixed(2)}" match-home-name="${todayMatch.home_team}" match-away-name="${todayMatch.away_team}" match-market="${["1", "X", "2"].includes(todayMatch.odd.split(',')[1].split('|')[2]) ? "Rezultat final" : todayMatch.odd.split(',')[1].split('|')[2]}"  match-market-option="X " coef-id="${todayMatch.odd.split(',')[1].split('|')[0]}" bet-id="${(todayMatch.odd.split(',')[1].split('|')[0])}" game-id="${todayMatch.id}"><i>X</i><i>${(Math.floor((parseFloat(todayMatch.odd.split(',')[1].split('|')[1]) + Number.EPSILON) * 100) / 100).toFixed(2)}</i></div>
                      <div class="singleAwayOdd bettingBtn ${Math.floor((parseFloat(todayMatch.odd.split(',')[2].split('|')[1]) + Number.EPSILON) * 100) / 100 == 1 ? 'disabledBtn' : ''} ${todayMatch.odd.split(',')[2].split('|')[0]}" match-odd="${(Math.floor((parseFloat(todayMatch.odd.split(',')[2].split('|')[1]) + Number.EPSILON) * 100) / 100).toFixed(2)}" match-home-name="${todayMatch.home_team}" match-away-name="${todayMatch.away_team}" match-market="${["1", "X", "2"].includes(todayMatch.odd.split(',')[2].split('|')[2]) ? "Rezultat final" : todayMatch.odd.split(',')[2].split('|')[2]}"  match-market-option="2 " coef-id="${todayMatch.odd.split(',')[2].split('|')[0]}" bet-id="${(todayMatch.odd.split(',')[2].split('|')[0])}" game-id="${todayMatch.id}"><i>2</i><i>${(Math.floor((parseFloat(todayMatch.odd.split(',')[2].split('|')[1]) + Number.EPSILON) * 100) / 100).toFixed(2)}</i></div>
                    </div>
                  </div>`;
              } catch {}
            }
          })
          matchesView += `
          <div class="singleHeaderHolderLabel fourColumn">
          <div class="singleHeaderLabel">${leagueName}</div>
          <div class="singleHeaderLabel">1</div>
          <div class="singleHeaderLabel">x</div>
          <div class="singleHeaderLabel">2</div>
        </div>${singleDateView}`
      });
      return matchesView;
    }

    todayMatchesView = generateMatchesView(todayMatches);
    next2hMatchesView = generateMatchesView(next2hMatches);
    next4hMatchesView = generateMatchesView(next4hMatches);
    

    if (mainLeagueMatches) {
      mainLeagueMatches.forEach((mainLeagueMatche) => {
        if (mainLeagueMatche.odd) {
          const date = new Date(mainLeagueMatche.game_date);
          let dd = String(date.getDate()).padStart(2, '0');
          let mm = String(date.getMonth() + 1).padStart(2, "0"); //January is 0!
          let yyyy = date.getFullYear();

          const time = `${mainLeagueMatche.game_time.split(":")[0]}:${mainLeagueMatche.game_time.split(":")[1]}`
          mainLeagueMatchesView = mainLeagueMatchesView + `<div class="featuredPrematchItem">
                <a href="#/Match/${mainLeagueMatche.id}" class="featuredMatchName">
                  <span>
                    <span class="kfm-Competitor_TeamKit">
                      <object data="${window.location.pathname}img/kit-black.svg" type="image/svg">
                        <img class="ml-TeamKit_SVG" src="${window.location.pathname}img/kit-black.svg" />
                      </object>
                    </span>
                    ${mainLeagueMatche.home_team}
                  </span>
                  <span>
                    <span class="kfm-Competitor_TeamKit">
                      <object data="${window.location.pathname}img/kit-yellow.svg" type="image/svg">
                        <img class="ml-TeamKit_SVG" src="${window.location.pathname}img/kit-yellow.svg" />
                      </object>
                    </span>
                    ${mainLeagueMatche.away_team}
                  </span>
                </a>
                <span class="featurePreMatchDate">${dd}/${mm} ${time}</span>
                        <span class="numberofmarkets">${mainLeagueMatche.count_options} ></span>
                <div class="featuredMatchBtn">
                     <div class="singleHomeOdd bettingBtn ${Math.floor((parseFloat(mainLeagueMatche.odd.split(',')[0].split('|')[1]) + Number.EPSILON) * 100) / 100 == 1 ? 'disabledBtn' : ''} ${mainLeagueMatche.odd.split(',')[0].split('|')[0]}" match-odd="${(Math.floor((parseFloat(mainLeagueMatche.odd.split(',')[0].split('|')[1]) + Number.EPSILON) * 100) / 100).toFixed(2)}" match-home-name="${mainLeagueMatche.home_team}" match-away-name="${mainLeagueMatche.away_team}" match-market="${["1", "X", "2"].includes(mainLeagueMatche.odd.split(',')[0].split('|')[2]) ? "Rezultat final" : mainLeagueMatche.odd.split(',')[0].split('|')[2]}"  match-market-option="1 " coef-id="${mainLeagueMatche.odd.split(',')[0].split('|')[0]}" bet-id="${(mainLeagueMatche.odd.split(',')[0].split('|')[0])}" game-id="${mainLeagueMatche.id}"><i>1</i><i>${(Math.floor((parseFloat(mainLeagueMatche.odd.split(',')[0].split('|')[1]) + Number.EPSILON) * 100) / 100).toFixed(2)}</i></div>
                     <div class="singleDrawOdd bettingBtn ${Math.floor((parseFloat(mainLeagueMatche.odd.split(',')[1].split('|')[1]) + Number.EPSILON) * 100) / 100 == 1 ? 'disabledBtn' : ''} ${mainLeagueMatche.odd.split(',')[1].split('|')[0]}" match-odd="${(Math.floor((parseFloat(mainLeagueMatche.odd.split(',')[1].split('|')[1]) + Number.EPSILON) * 100) / 100).toFixed(2)}" match-home-name="${mainLeagueMatche.home_team}" match-away-name="${mainLeagueMatche.away_team}" match-market="${["1", "X", "2"].includes(mainLeagueMatche.odd.split(',')[1].split('|')[2]) ? "Rezultat final" : mainLeagueMatche.odd.split(',')[1].split('|')[2]}"  match-market-option="X " coef-id="${mainLeagueMatche.odd.split(',')[1].split('|')[0]}" bet-id="${(mainLeagueMatche.odd.split(',')[1].split('|')[0])}" game-id="${mainLeagueMatche.id}"><i>X</i><i>${(Math.floor((parseFloat(mainLeagueMatche.odd.split(',')[1].split('|')[1]) + Number.EPSILON) * 100) / 100).toFixed(2)}</i></div>
                     <div class="singleAwayOdd bettingBtn ${Math.floor((parseFloat(mainLeagueMatche.odd.split(',')[2].split('|')[1]) + Number.EPSILON) * 100) / 100 == 1 ? 'disabledBtn' : ''} ${mainLeagueMatche.odd.split(',')[2].split('|')[0]}" match-odd="${(Math.floor((parseFloat(mainLeagueMatche.odd.split(',')[2].split('|')[1]) + Number.EPSILON) * 100) / 100).toFixed(2)}" match-home-name="${mainLeagueMatche.home_team}" match-away-name="${mainLeagueMatche.away_team}" match-market="${["1", "X", "2"].includes(mainLeagueMatche.odd.split(',')[2].split('|')[2]) ? "Rezultat final" : mainLeagueMatche.odd.split(',')[2].split('|')[2]}"  match-market-option="2 " coef-id="${mainLeagueMatche.odd.split(',')[2].split('|')[0]}" bet-id="${(mainLeagueMatche.odd.split(',')[2].split('|')[0])}" game-id="${mainLeagueMatche.id}"><i>2</i><i>${(Math.floor((parseFloat(mainLeagueMatche.odd.split(',')[2].split('|')[1]) + Number.EPSILON) * 100) / 100).toFixed(2)}</i></div>
                </div>
          </div>`
        }
      });
    }

    let sportsView = '';
    if (sports) {
      
      sports.forEach((sport, i) => {
        // if (i == 1 && getPokerUrl() != '#/') {
        //   sportsView = sportsView + `
        //     <a href="${getPokerUrl()}" target="_blank" class="betModuleSportBtn active">
        //       <i class="sport-poker"></i>
        //       <span>POKER</span>
        //     </a>
        //   `
        // }

        if (sport && (sport.id != 13 || sport.id != 15)) {
          sportsView = sportsView + `<a href="#/categories/${sport.id}" sportid="${sport.id}" class="betModuleSportBtn active hd-${sport.name}">
          <i class="sport-${sport.name}"></i>
          <span>${_t(sport.name)}</span>
        </a>`
        }

      });
    }




    let topFiveLeagues = (blockedFootball ? Promise.resolve([]) : getTopFiveLeagues()).then((value) => {
      let getTopFiveLeaguesView = "";
      value.forEach((topFiveLeague) => {
        getTopFiveLeaguesView =
          getTopFiveLeaguesView +
          `<a class="leagueListContentItem" href="#/games/${topFiveLeague.id}" data-id="${topFiveLeague.id}">${topFiveLeague.name}</a>`;
      });

      document.getElementById(
        "leagueHeaderContentF"
      ).innerHTML = getTopFiveLeaguesView;

      updateMatch();
    });

    let topTenMatchGames = (blockedFootball ? Promise.resolve([]) : getTopTenMatchGames()).then((value) => {
      let getTopTenMatchGamesView = "";
      value.forEach((topTenMatchGame) => {
        if (!topTenMatchGame.odd) {
          return;
        }
        getTopTenMatchGamesView =
          getTopTenMatchGamesView +
          `<div class="singleGameContent">
                           <a class="singleTeamNames" href="#/Match/${topTenMatchGame.id
          }" data-id="${topTenMatchGame.id}">
                               <div class="singleDateColumn">
                                  <span>${topTenMatchGame.game_time.split(':')[0]}:${topTenMatchGame.game_time.split(':')[1]}</span>
                        <span class="numberofmarkets">${topTenMatchGame.count_options} ></span>
                               </div>
                               <div class="singleDetailsColumn">
                                 <div class="singleTeamRowLabel">
                                   <span class="singleHomeName">${topTenMatchGame.home_team
          }</span>
                                   <span class="gameSingleHomeScore"></span>
                                 </div>
                                 <div class="singleTeamRowLabel">
                                   <span class="singleAwayName">${topTenMatchGame.away_team
          }</span>
                                   <span class="gameSingleAwayScore"></span>
                                 </div>
                               </div>
                           </a>
                           <div class="singleHomeOdd bettingBtn  ${Math.floor((parseFloat(topTenMatchGame.odd.split(',')[0].split('|')[1]) + Number.EPSILON) * 100) / 100 == 1 ? 'disabledBtn' : ''} ${topTenMatchGame.odd.split(
            ","
          )[0].split('|')[0]
          }" match-odd="${Math.floor((parseFloat(topTenMatchGame.odd.split(',')[0].split('|')[1]) + Number.EPSILON) * 100) / 100
          }" match-home-name="${topTenMatchGame.home_team}" match-away-name="${topTenMatchGame.away_team
          }" match-market="Rezultat Final"  match-market-option="1 " coef-id="${topTenMatchGame.odd.split(",")[0].split('|')[0]
          }" bet-id="${topTenMatchGame.odd.split(",")[0].split('|')[0]
          }" game-id="${topTenMatchGame.id}">${(Math.floor((parseFloat(topTenMatchGame.odd.split(',')[0].split('|')[1]) + Number.EPSILON) * 100) / 100).toFixed(2)
          }</div>
                           <div class="singleDrawOdd bettingBtn  ${Math.floor((parseFloat(topTenMatchGame.odd.split(',')[1].split('|')[1]) + Number.EPSILON) * 100) / 100 == 1 ? 'disabledBtn' : ''}  ${topTenMatchGame.odd.split(
            ","
          )[1].split('|')[0]
          }" match-odd="${(Math.floor((parseFloat(topTenMatchGame.odd.split(',')[1].split('|')[1]) + Number.EPSILON) * 100) / 100).toFixed(2)
          }" match-home-name="${topTenMatchGame.home_team}" match-away-name="${topTenMatchGame.away_team
          }" match-market="Rezultat Final"  match-market-option="X " coef-id="${topTenMatchGame.odd.split(",")[1].split('|')[0]
          }" bet-id="${topTenMatchGame.odd.split(",")[1].split('|')[0]
          }" game-id="${topTenMatchGame.id}">${(Math.floor((parseFloat(topTenMatchGame.odd.split(',')[1].split('|')[1]) + Number.EPSILON) * 100) / 100).toFixed(2)
          }</div>
                           <div class="singleAwayOdd bettingBtn  ${(Math.floor((parseFloat(topTenMatchGame.odd.split(',')[2].split('|')[1]) + Number.EPSILON) * 100) / 100).toFixed(2) == 1 ? 'disabledBtn' : ''} ${topTenMatchGame.odd.split(
            ","
          )[2].split('|')[0]
          }" match-odd="${(Math.floor((parseFloat(topTenMatchGame.odd.split(',')[2].split('|')[1]) + Number.EPSILON) * 100) / 100).toFixed(2)
          }" match-home-name="${topTenMatchGame.home_team}" match-away-name="${topTenMatchGame.away_team
          }" match-market="Rezultat Final"  match-market-option="2 " coef-id="${topTenMatchGame.odd.split(",")[2].split('|')[0]
          }" bet-id="${topTenMatchGame.odd.split(",")[2].split('|')[0]
          }" game-id="${topTenMatchGame.id}">${(Math.floor((parseFloat(topTenMatchGame.odd.split(',')[2].split('|')[1]) + Number.EPSILON) * 100) / 100).toFixed(2)
          }</div>
                         </div>`;
      });

      document.getElementById(
        "getTopTenMatchGamesViewF"
      ).innerHTML = getTopTenMatchGamesView;

      updateMatch();
    });
    let topTenLiveGames = (blockedFootball ? Promise.resolve([]) : getTopTenLiveGames()).then((value) => {
      let getTopTenLiveGamesView = "";

      value.forEach((topTenLiveGame) => {
        if (topTenLiveGame.id != 372481) {
          getTopTenLiveGamesView =
            getTopTenLiveGamesView + getLiveTemplate(topTenLiveGame);

          const check = timers.find((a) => a.game_id == topTenLiveGame.id);
          const timerId = setInterval(() => liveTimer(`${topTenLiveGame.id}-timer`), 1000);
          if (check) {
            clearInterval(check.timerId);
            check.timerId = timerId;
          } else {
            timers.push({
              game_id: topTenLiveGame.id,
              timerId,
            });
          }
        }


      });
      document.getElementById(
        "getTopTenLiveGamesViewF"
      ).innerHTML = getTopTenLiveGamesView;

      updateMatch();
    });

    let view = /*html*/ `
          <div class="pageSection">
              <div class="firstColumn">
              <div class="betModule liveInModule sportsLanding">
                <div class="betModuleTabs">
                   <div class="betModuleTabsBtn">
                     ${sportsView}
                   </div>
                 </div>
               </div>
               <div class="jcakpotHolder jackpotHolderMain" hidden>
    <div class="jackpotHeader">
        <div class="jackpotLeftHeader">
            <span>${_t('Live jackpot')}</span>
            <span>${parseFloat(localStorage.getItem('jackpot_live') ? parseFloat(localStorage.getItem('jackpot_live')) : 0).toFixed(2)}&euro;</span>
        </div>
        <div class="jackpotRightHeader">
            <span>${_t('Prematch jackpot')}</span>
            <span>${parseFloat(localStorage.getItem('jackpot_prematch') ? parseFloat(localStorage.getItem('jackpot_prematch')) : 0).toFixed(2)}&euro;</span>
        </div>
    </div>
</div>
          <div class="betModule liveInModule accordionDisable" id="todayAccordion">
            <div class="betModuleHeaderContainer">
              <a class="betModuleHeaderBtn">
                <span class="highlightColored">${_t('Futboll')}</span>
                <span>${_t('Ndeshjet Sot')}</span>
                <span class="yellowColored"></span>
              </a>
              <svg class="arrowDownIcon" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Capa_1" x="0px" y="0px" width="451.847px" height="451.847px" viewBox="0 0 451.847 451.847" style="enable-background:new 0 0 451.847 451.847;" xml:space="preserve">
                <g>
                  <path d="M225.923,354.706c-8.098,0-16.195-3.092-22.369-9.263L9.27,151.157c-12.359-12.359-12.359-32.397,0-44.751   c12.354-12.354,32.388-12.354,44.748,0l171.905,171.915l171.906-171.909c12.359-12.354,32.391-12.354,44.744,0   c12.365,12.354,12.365,32.392,0,44.751L248.292,345.449C242.115,351.621,234.018,354.706,225.923,354.706z"/>
                </g>
              </svg>
            </div>
          </div>
          <div class="featuredPrematchWrappers" id="todayAccordionContent">
            <div class="featuredPrematchSlider">
              ${todayMatchesView}
            </div>
          </div>

          <div class="betModule liveInModule accordionDisable" id="today2hAccordion" style="border-top: 1px solid var(--InTitleLightColor);">
            <div class="betModuleHeaderContainer">
              <a class="betModuleHeaderBtn">
                <span class="highlightColored">${_t('Futboll')}</span>
                <span>${_t('Ndeshjet 2 orët e ardhshme')}</span>
                <span class="yellowColored"></span>
              </a>
              <svg class="arrowDownIcon" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Capa_1" x="0px" y="0px" width="451.847px" height="451.847px" viewBox="0 0 451.847 451.847" style="enable-background:new 0 0 451.847 451.847;" xml:space="preserve">
                <g>
                  <path d="M225.923,354.706c-8.098,0-16.195-3.092-22.369-9.263L9.27,151.157c-12.359-12.359-12.359-32.397,0-44.751   c12.354-12.354,32.388-12.354,44.748,0l171.905,171.915l171.906-171.909c12.359-12.354,32.391-12.354,44.744,0   c12.365,12.354,12.365,32.392,0,44.751L248.292,345.449C242.115,351.621,234.018,354.706,225.923,354.706z"/>
                </g>
              </svg>
            </div>
          </div>
          <div class="featuredPrematchWrappers" id="today2hAccordionContent">
            <div class="featuredPrematchSlider">
              ${next2hMatchesView}
            </div>
          </div>

          <div class="betModule liveInModule accordionDisable" id="today4hAccordion" style="border-top: 1px solid var(--InTitleLightColor);">
            <div class="betModuleHeaderContainer">
              <a class="betModuleHeaderBtn">
                <span class="highlightColored">${_t('Futboll')}</span>
                <span>${_t('Ndeshjet 4 orët e ardhshme')}</span>
                <span class="yellowColored"></span>
              </a>
              <svg class="arrowDownIcon" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Capa_1" x="0px" y="0px" width="451.847px" height="451.847px" viewBox="0 0 451.847 451.847" style="enable-background:new 0 0 451.847 451.847;" xml:space="preserve">
                <g>
                  <path d="M225.923,354.706c-8.098,0-16.195-3.092-22.369-9.263L9.27,151.157c-12.359-12.359-12.359-32.397,0-44.751   c12.354-12.354,32.388-12.354,44.748,0l171.905,171.915l171.906-171.909c12.359-12.354,32.391-12.354,44.744,0   c12.365,12.354,12.365,32.392,0,44.751L248.292,345.449C242.115,351.621,234.018,354.706,225.923,354.706z"/>
                </g>
              </svg>
            </div>
          </div>
          <div class="featuredPrematchWrappers" id="today4hAccordionContent">
            <div class="featuredPrematchSlider">
              ${next4hMatchesView}
            </div>
          </div>
        
            <div class="betModule liveInModule accordionDisable widthFull ${mainLeagueMatchesView == '' ? 'hideMe' : ''} " style="height: 34px; border-top: 1px solid var(--TitleBackBorderColor)" hidden>
                 <div class="betModuleHeaderContainer">
                   <a class="betModuleHeaderBtn">
                     <span style="line-height: 32px;">${mainLeagueName}</span>
                     <span class="yellowColored"></span>
                   </a>
                   <a class="betHeaderEventBtn" href="#/inPlay">

                   </a>
                 </div>
            </div>
            <div class="featuredPrematchWrapper widthFull" hidden>
                <div class="featuredPrematchSlider ">
                    ${mainLeagueMatchesView}
                </div>
            </div>
            <div class="betModule liveInModule accordionDisable" style="height: 34px; ">
                <div class="betModuleHeaderContainer">
                   <a class="betModuleHeaderBtn">
                     <span style="line-height: 32px;">${_t('Ndeshjet Kryesore')}</span>
                     <span class="yellowColored"></span>
                   </a>
                   <a class="betHeaderEventBtn" href="#/inPlay">

                   </a>
                </div>
            </div>
            <div class="featuredPrematchWrapper">
                <div class="featuredPrematchSlider">
                    ${featuredPrematchView}
                </div>
            </div>
                <div class="betModule liveInModule accordionDisable">
                 <div class="betModuleHeaderContainer">
                   <a class="betModuleHeaderBtn">
                     <strong style="font-size: 21px"><span>${_t('NE KOHE')}</span>
                     <span class="yellowColored">${_t('REALE')}</span></strong>
                   </a>
                   <a class="betHeaderEventBtn" href="#/inPlay">
                     <span>${_t('Te Gjitha Ndeshjet >')}</span>
                   </a>
                 </div>
                 <div class="singleHeaderHolderLabel fourColumn">
                      <div class="singleHeaderLabel">Soccer</div>
                      <div class="singleHeaderLabel">1</div>
                      <div class="singleHeaderLabel">x</div>
                      <div class="singleHeaderLabel">2</div>
                    </div>
                 <div class="betModuleContentContainer">
                   <div class="betModuleSportAccordion moduleFirstColour soccerTab">
                     <div class="moduleSportAccordionContent">
                       <div class="moduleSportSingleAccordion">
                         <div class="moduleSportSingleLeague">
                           <div class="moduleSportSingleLeagueContent gameTableContent" id="getTopTenLiveGamesViewF">
                           </div>
                           <a class="view-all-row" href="#/inPlay">
                            <span>${_t('Shiko te gjitha ne kohe reale')}</span>
                            <span>${_t('Te gjitha ndeshjet')}</span>
                           </a>
                         </div>
                       </div>
                     </div>
                   </div>
                 </div>
               </div>
               <div class="gameTableHeader m-t-6">
                    <span class="gameTableHeaderTitle">${_t('Ndeshjet ne vijim')}</span>
                </div>
                <div class="singleHeaderHolderLabel fourColumn">
                      <div class="singleHeaderLabel">Soccer</div>
                      <div class="singleHeaderLabel">1</div>
                      <div class="singleHeaderLabel">x</div>
                      <div class="singleHeaderLabel">2</div>
                    </div>
                <div class="gameTableContent">
                     <div class="gameTableContent" id="getTopTenMatchGamesViewF">
                                             </div>
                </div>

                <div class="betModule liveInModule m-t-6 accordionDisable">
                     <div class="betModuleHeaderContainer makeFull">
                       <a class="betModuleHeaderBtn">
                         <span>${_t('Kampionatet kryesore')}</span>
                         <span class="yellowColored"></span>
                       </a>
                     </div>
                </div>
                <div class="leagueHeaderContent" id="leagueHeaderContentF">
                </div>
            </div>
       `;

    return view;
  },
  after_render: async (socket) => {
    if (LOGIN_PROTECTED === true && !localStorage.getItem('access_token')) {
      return;
    }

    $('body').on('click', '.sliderItemCasino', async function (e) {
      const event = new CustomEvent("loadLiveCasino", {
      });
      window.dispatchEvent(event);
    });


    $('body').on('click', '#todayAccordion', function (e) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      const show = $('body #todayAccordionContent').hasClass('show');
      toggleAccordion('#todayAccordion', show);
    });

    $('body').on('click', '#today2hAccordion', function (e) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      const show = $('body #today2hAccordionContent').hasClass('show');
      toggleAccordion('#today2hAccordion', show);
    });

    $('body').on('click', '#today4hAccordion', function (e) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      const show = $('body #today4hAccordionContent').hasClass('show');
      toggleAccordion('#today4hAccordion', show);
    });



    socket.emit('connectToRoom', { room: "prematch-games" });
    socket.emit('connectToRoom', { room: "inplay" });
    $('body .menuItem a').removeClass('active');
    $('body .mainLeftMenuItem a').removeClass('active');
    $('body #inPlayPage').removeClass('active');
    $('body .leftMenuHome ').addClass('active');
    $('body .homeLeftBtn').addClass('active');
    $('body .betModuleTabs').css({
        'width': ($('.betModuleTabs .betModuleTabsBtn a:visible').length * 77) + 'px'
    });
    $('body .featuredPrematchWrapper').each(function () {
      let featuredSliderWidth = 0;
      $(this).children('.featuredPrematchSlider').children('.featuredPrematchItem').each(function () {
        featuredSliderWidth += $(this).outerWidth() + 2;
      });
      $(this).children('.featuredPrematchSlider').css({
        'width': featuredSliderWidth - 3 + 'px'
      });
    });

    toggleAccordion('#todayAccordion', !(localStorage.getItem('today')));
    localStorage.removeItem('today');


  },
  on_unload: async (socket) => {
    socket.emit('leaveRoom', { room: "prematch-games" });
    socket.emit('leaveRoom', { room: "inplay" });
    timers.forEach(timer => clearInterval(timer.timerId))
  },
};


function toggleAccordion(selecor, show) {
  if (show) {
    $(selecor).removeClass('rotate');
    $(`${selecor}Content`).removeClass('show');
    $(`${selecor}Content`).css({
      'height': 0 + 'px'
    });
  } else {
    let getHeight = $(`${selecor}Content .featuredPrematchSlider`).outerHeight();
    $(selecor).addClass('rotate');
    $(`${selecor}Content`).addClass('show');
    $(`${selecor}Content`).css({
      'height': getHeight + 'px'
    });
  }
}


function liveTimer(id) {
  const current_minute = $(`#${id}`).text();
  if (!current_minute || current_minute == "" || current_minute == "45:00")
    return;
  let minutes = parseInt(current_minute.split(":")[0]);
  let seconds = parseInt(current_minute.split(":")[1]);

  if (seconds == 59) {
    minutes += 1;
    seconds = 0;
  } else seconds += 1;

  $(`#${id}`).text(
    `${minutes < 10 ? `0${minutes}` : minutes}:${seconds < 10 ? `0${seconds}` : seconds
    }`
  );
}

export default Landing;
